import FrostedTab from './FrostedTab';
import './style/index.less';

export default FrostedTab;
